import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { ProjectResolver } from '@/features/shell/project-resolver';

/** `/$tenant/jobs` — entrée hors projet : redirige vers `/$tenant/projects/$projectId/jobs`. */
export const Route = createFileRoute('/$tenant/jobs/')({ component: JobsRoute });

function JobsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="jobs" crumbs={[{ label: t('nav.items.jobs') }]}>
      <ProjectResolver tenantId={tenant} section="jobs" />
    </ConsoleShell>
  );
}
